import { oturumDeposuKullan } from '../durum/oturum-deposu';

/**
 * YETKİ KODLARI — `prisma/seed/06_belge_yetki.sql` ile birebir.
 *
 * FRONTEND'DE YETKİ DENETİMİ YAPILMAZ. Sunucu her istekte yeniden denetler
 * ve son söz onundur. Buradaki kontrol yalnız kullanıcıyı erişemeyeceği
 * ekrandan ve boşuna 403 alacağı düğmeden korur.
 *
 * Kod adı UYDURULAMAZ: seed'de olmayan bir kod tüm kullanıcılarda sessizce
 * `false` döner ve menü öğesi hiç görünmez — hata da vermez.
 */
export const YETKI = {
  SISTEM_YONET: 'SISTEM_YONET',
  BIRIM_YONET: 'BIRIM_YONET',
  BIRIM_KAPAT: 'BIRIM_KAPAT',
  EKIP_KUR: 'EKIP_KUR',

  PERSONEL_YONET: 'PERSONEL_YONET',
  PERSONEL_GORUNTULE: 'PERSONEL_GORUNTULE',
  UCRET_GORUNTULE: 'UCRET_GORUNTULE',
  SAGLIK_GORUNTULE: 'SAGLIK_GORUNTULE',
  BELGE_YONET: 'BELGE_YONET',

  ATAMA_YAP: 'ATAMA_YAP',
  ATAMA_ONAYLA: 'ATAMA_ONAYLA',

  VARDIYA_PLAN_URET: 'VARDIYA_PLAN_URET',
  VARDIYA_PLAN_ONAYLA: 'VARDIYA_PLAN_ONAYLA',
  VARDIYA_PLAN_DUZELT: 'VARDIYA_PLAN_DUZELT',

  IZIN_TALEP: 'IZIN_TALEP',
  IZIN_ONAY_ILK: 'IZIN_ONAY_ILK',
  IZIN_ONAY_SON: 'IZIN_ONAY_SON',

  GOREV_TIPI_YONET: 'GOREV_TIPI_YONET',
  GOREV_OLUSTUR: 'GOREV_OLUSTUR',

  MESAI_KAYDI_BAS: 'MESAI_KAYDI_BAS',
  PUANTAJ_GORUNTULE: 'PUANTAJ_GORUNTULE',
  PUANTAJ_DUZELT: 'PUANTAJ_DUZELT',
  PUANTAJ_BASKA_ADINA: 'PUANTAJ_BASKA_ADINA',
  DENETIM_EKRANI: 'DENETIM_EKRANI',

  MESAI_ON_IZIN_TALEP: 'MESAI_ON_IZIN_TALEP',
  MESAI_ON_IZIN_ONAY: 'MESAI_ON_IZIN_ONAY',

  DONEM_KAPAT: 'DONEM_KAPAT',
  MUTABAKAT_GIR: 'MUTABAKAT_GIR',
  ITIRAZ_ET: 'ITIRAZ_ET',
  ITIRAZ_KARAR: 'ITIRAZ_KARAR',

  PARAMETRE_YONET: 'PARAMETRE_YONET',
  RAPOR_GORUNTULE: 'RAPOR_GORUNTULE',
} as const;

export type YetkiKodu = (typeof YETKI)[keyof typeof YETKI];

/**
 * FAZ 2'YE ERTELENEN DÖRT KOD — `YETKI` içine ALINMADI.
 *
 * `BURO_PUANTAJ_GIR`, `KONUM_GORUNTULE`, `TEFTIS_ERISIM`,
 * `RAPOR_TOPLU_GORUNTULE` seed'de tanımlı ama hiçbir uçta kullanılmıyor.
 * Buraya eklenselerdi menüye bağlanabilir ve tıklanan ekran boş çıkardı.
 */

/**
 * Verilen kodlardan EN AZ BİRİ varsa true.
 *
 * Depo aboneliği kurar; yetkiler değişince bileşen yeniden render edilir.
 * Bileşen dışında (yönlendirme koruması gibi) kullanılacaksa
 * `oturumDeposuKullan.getState()` ile ayrı bir sürüm gerekir.
 */
export function yetkiKullan(...kodlar: YetkiKodu[]): boolean {
  return oturumDeposuKullan((d) => kodlar.some((k) => d.yetkiler.some((y) => y.kod === k)));
}

/**
 * Yetki listesi sunucudan geldi mi.
 *
 * `yetkiKullan` yetkiler henüz gelmemişken de `false` döner ve iki durum
 * ayırt edilemez. Başlangıç durumunu yetkiye göre seçen ekranlar
 * (sekme, varsayılan süzgeç) ve `enabled` koşulları bunu beklemeli;
 * beklemezlerse doğrudan adrese F5 atan kullanıcı yanlış görünümde açılır.
 */
export function yetkilerHazirKullan(): boolean {
  return oturumDeposuKullan((d) => d.yetkilerYuklendiMi);
}
